import React from 'react'
import { DemoBanner } from 'newComponents'
import OldCtas from '../../components/ClosingCTAs.js'
import './styles.scss'

const ClosingCta = (props) => {
  const { data } = props
  const { primary } = data
  const { old_version: oldVariant } = primary

  return (
    <div className={`closing-ctas-slice ${oldVariant ? 'old' : ''}`}>{oldVariant ? <OldCtas /> : <DemoBanner />}</div>
  )
}

export default ClosingCta
